import React from 'react';

export default function ChecklistPraBerangkat() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Checklist Pra-Berangkat</h1>
      <p className="text-gray-500">Halaman Checklist Pra-Berangkat</p>
    </div>
  );
}
